<div mat-dialog-container *ngIf="data.title">
  <div class="close-row" *ngIf="data.closeButton">
    <a (click)="closeLeaveModal()">
      <img
        class="close-icon"
        src="assets/images/shared/Icon - Close - Active.svg"
      />
    </a>
  </div>
  <div mat-dialog-content style="padding: 0">
    <div
      class="body-modal"
      [ngClass]="{
        'padding-top':
          data.title == 'MODALS.CROSS_SELL.CREATE_SUCCESS_TITLE' ||
          data.title == 'MODALS.CHANGE_PASSWORD.LEAVE_TITLE' ||
          data.title == 'Something went wrong.',
      }"
    >
      <img *ngIf="data.imageUrl" src="{{ data.imageUrl }}" />
      <div *ngIf="data.title">
        <span class="modal-title-font"> {{ data.title | translate }}</span>
      </div>
      <div class="line-break" *ngIf="data.subHeading">
        <span
          *ngIf="data.subHeading && data.subHeading != 'adminSubHeading'"
          class="modal-text-font modal-subheading"
          [ngClass]="{ 'text-padding': data.title === 'Limit Exceeded' }"
        >
          {{ data.subHeading | translate }}
        </span>
        <span
          *ngIf="data.subHeading && data.subHeading == 'adminSubHeading'"
          class="modal-text-font modal-subheading"
        >
          {{ "LOGIN.FORM.HELPDESK_CONTACT_PREFIX" | translate }}
          <span class="bolded">+603 4065 7065</span>
          {{ "LOGIN.FORM.HELPDESK_CONTACT_JOINER" | translate }}
          <span class="bolded">alpha.helpdesk&#64;allianz.com.my</span>
        </span>

        <span *ngIf="data.subHeading2" class="modal-text-font">
          {{ data.subHeading2 | translate }}
        </span>
      </div>
    </div>
  </div>
  <mat-dialog-actions align="center">
    <div nxLayout="grid" style="width: 100%; padding: 0">
      <div
        nxRow
        class="std-pd-top-m modal-action"
        [ngClass]="{
          'padding-bottom':
            data.title == 'MODALS.CROSS_SELL.CREATE_SUCCESS_TITLE' ||
            data.title == 'MODALS.CHANGE_PASSWORD.LEAVE_TITLE',
        }"
      >
        <div
          nxCol="12,6"
          class="modal-action-button mobile-margin-bottom"
          *ngIf="data.buttonText1"
        >
          <button
            mat-button
            type="button"
            nxButton="secondary medium"
            [mat-dialog-close]="false"
            class="modal-button-font"
          >
            {{ data.buttonText1 | translate }}
          </button>
        </div>
        <div
          nxCol="12,6"
          class="modal-action-button"
          *ngIf="data.buttonText2 && data.buttonText1"
        >
          <button
            mat-button
            type="button"
            nxButton="primary medium"
            [mat-dialog-close]="true"
            class="modal-button-font"
          >
            {{ data.buttonText2 | translate }}
          </button>
        </div>
        <div
          class="modal-action-button event-management-action-button"
          *ngIf="data.buttonText2 && !data.buttonText1"
        >
          <button
            mat-button
            type="button"
            nxButton="primary medium"
            [mat-dialog-close]="true"
            class="modal-button-font"
            [ngClass]="
              data.buttonText2 ==
              'MODALS.EVENT_MANAGEMENT.BACK_TO_EVENT_MANAGEMENT'
                ? 'no-break'
                : ''
            "
          >
            <!-- [ngClass]="isShowTag ? 'tag-container' : 'display-none'" -->
            {{ data.buttonText2 | translate }}
          </button>
        </div>
      </div>
    </div>
  </mat-dialog-actions>
</div>
